import { ReactElement, Children, cloneElement, ReactNode } from 'react';
import { debug } from 'zf-web-infra';
import { Icons } from '@common';
import * as Base from '../../../base';
import { OperatorMenuItemProps, OperatorMenuProps } from './types';

export function OperatorMenu(props: OperatorMenuProps): ReactElement | null {
  const { title, items = [], icon, children, loading } = props;

  if (items.length === 0 && children == null) {
    return null;
  }

  const dropdownRender = (menu: ReactNode): ReactNode => {
    let customMenu: ReactElement | null = null;
    const filteredChildren = children?.filter(item => item.key != null);
    if (filteredChildren != null) {
      customMenu = (
        <Base.Menu>
          {
            Children.map(filteredChildren, child => (
              <Base.Menu.Item key={child.key} {...child.props}>
                {child.props.label ?? child.props.children}
              </Base.Menu.Item>
            ))
          }
        </Base.Menu>
      );
    }

    return (
      <>
        {items.length > 0 ? cloneElement(menu as ReactElement) : null}
        {customMenu}
      </>
    );
  };

  return (
    <Base.Dropdown placement='bottomRight' menu={{ items }} dropdownRender={dropdownRender}>
      <Base.Button loading={loading}>
        {icon}
        <Base.Space>
          {title}
          <Icons name='DownOutlined' />
        </Base.Space>
      </Base.Button>
    </Base.Dropdown>
  );
}

function MenuItem(props: OperatorMenuItemProps): ReactElement | null {
  debug.common('MenuItem', props);
  return null;
}

OperatorMenu.Item = MenuItem;
